/**
 * Created by Jan Bradac on 3.8.2016.
 */

(function (Lfl, $, undefined) {
    /**
     * @memberOf Lfl
     */
    Lfl.ActionHandlers;

    (function (ActionHandlers, $, undefined) {
        /**
         * @memberOf Lfl.ActionHandlers
         */
        Lfl.ActionHandlers.OnDragHandlers;

        (function (OnDragHandlers, $, undefined) {
            if (Lfl.Files.isLoadedAlready(Lfl.ActionHandlers.OnDragHandlers, 'OnDragHandlersManager')) {
                return;
            }

            /*
             |==============================================================================================================
             | Documentation
             |==============================================================================================================
             */

            /**
             * Handles registration and calling of on drag handlers.
             *
             * The elements for which ODHs are to be active are registered here.
             *
             * @memberOf Lfl.ActionHandlers.OnDragHandlers
             */
            Lfl.ActionHandlers.OnDragHandlers.OnDragHandlersManager;

            (function (OnDragHandlersManager, $, undefined) {
                /*
                 |===========================================================================================================
                 | Object definition
                 |===========================================================================================================
                 */

                /**
                 * The key under which handlers are stored in the element data attribute.
                 *
                 * @memberOf Lfl.ActionHandlers
                 * @type {string}
                 */
                var ON_DRAG_HANDLER_ID_DATA_KEY = "lfl-on-drag-handler-id";


                /**
                 * A collection of handlers indexed by
                 * @type {{} | Lfl.ActionHandlers.OnDragHandlers.ModalOdh[]}
                 */
                var registeredHandlers = {};

                /*
                 |-----------------------------------------------------------------------------------------------------------
                 | Public methods
                 |-----------------------------------------------------------------------------------------------------------
                 */

                /*
                 |-------------------------------------------------------------------------
                 | New handlers creation */

                /**
                 * Provides the handler registered under the provided id. A new instance creating method can be provided
                 * to create such an instance.
                 *
                 * @memberOf Lfl.ActionHandlers.OnDragHandlers.OnDragHandlersManager
                 */
                OnDragHandlersManager.getHandlerForId = function (odhId, newInstanceCreatingMethod) {
                    if (typeof registeredHandlers[odhId] === 'undefined') {
                        // If no instance is yet registered under this odhId, we try to create a new one.
                        if (typeof newInstanceCreatingMethod === 'undefined') {
                            // If the client code provided no way of creating the new instance, we let him know that
                            // we don't have such an instance...
                            return undefined;
                        } else {
                            registeredHandlers[odhId] = newInstanceCreatingMethod();
                        }
                    }

                    return registeredHandlers[odhId];
                };

                /**
                 * Registers a handler of drag events for the given element.
                 * @memberOf Lfl.ActionHandlers.OnDragHandlers.OnDragHandlersManager
                 */
                OnDragHandlersManager.register = function ($element, handler) {
                    if (typeof getElementHandlers($element) === 'undefined') {
                        $element.data(ON_DRAG_HANDLER_ID_DATA_KEY, []);
                    }

                    var handlers = $element.data(ON_DRAG_HANDLER_ID_DATA_KEY);
                    handlers.push(handler);
                };


                /*
                 |-------------------------------------------------------------------------
                 | On event methods. */

                /**
                 * Informs the handlers registered for the element about the dragging start event.
                 * @memberOf Lfl.ActionHandlers.OnDragHandlers.OnDragHandlersManager
                 */
                OnDragHandlersManager.onStart = function ($element, event) {
                    if (typeof getElementHandlers($element) === 'undefined') {
                        // The element has no handlers registered (which should be a perfectly valid condition) so we 
                        // allow the dragging to proceed.
                        return true;
                    }

                    var canProceed = true;

                    _.each(getElementHandlers($element),
                        function (/** Lfl.ActionHandlers.OnDragHandlers.ModalOdh */handler, key) {
                            if (handler.onStart($element, event) === false) {
                                canProceed = false;
                            }
                        });

                    return canProceed;
                };

                /**
                 * Informs the handlers registered for the element about the dragging stop event.
                 * @memberOf Lfl.ActionHandlers.OnDragHandlers.OnDragHandlersManager
                 * @param {jQuery} $element
                 * @param event
                 * @param {{}} callbacks
                 * @param {function} callbacks.success The method which will be called if all handlers allow the action.
                 * @param {function} callbacks.failure The method which will be called if at least one handler forbids
                 * the action.
                 * @param {Lfl.Tiem.Core.TiemOdhDataCrate} dataCrate // TODO allow for generic OdhDataCrate? Or make TiemODC generic?
                 * @returns void
                 */
                OnDragHandlersManager.onStop = function ($element, event, callbacks, dataCrate) {
                    if (typeof getElementHandlers($element) === 'undefined') {
                        // The element has no handlers registered (which should be a perfectly valid condition) so we
                        // allow the dragging to finish.
                        callbacks.success();
                        return;
                    }

                    var processor = new Lfl.ActionHandlers.OnDragHandlers.OnDragStopCallbacksProcessor(
                        getElementHandlers($element),
                        $element,
                        event,
                        callbacks,
                        dataCrate
                    );

                    processor.process();
                };

                /*
                 |-----------------------------------------------------------------------------------------------------------
                 | Private methods
                 |-----------------------------------------------------------------------------------------------------------
                 */

                function getElementHandlers($element) {
                    return $element.data(ON_DRAG_HANDLER_ID_DATA_KEY);
                }

            }(OnDragHandlers.OnDragHandlersManager = OnDragHandlers.OnDragHandlersManager || {}, jQuery));
        }(ActionHandlers.OnDragHandlers = ActionHandlers.OnDragHandlers || {}, jQuery));
    }(Lfl.ActionHandlers = Lfl.ActionHandlers || {}, jQuery));
}(window.Lfl = window.Lfl || {}, jQuery));
